var RewardUnlockStrategy = /* @__PURE__ */ ((RewardUnlockStrategy2) => {
  RewardUnlockStrategy2["Instant"] = "instant";
  RewardUnlockStrategy2["BrandedPurchase"] = "brandedPurchase";
  return RewardUnlockStrategy2;
})(RewardUnlockStrategy || {});
var UserRewardStatus = /* @__PURE__ */ ((UserRewardStatus2) => {
  UserRewardStatus2["Claimed"] = "claimed";
  UserRewardStatus2["Available"] = "available";
  UserRewardStatus2["Unavailable"] = "unavailable";
  return UserRewardStatus2;
})(UserRewardStatus || {});
var CheckoutEligibility = /* @__PURE__ */ ((CheckoutEligibility2) => {
  CheckoutEligibility2["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
  CheckoutEligibility2["CLIENT"] = "CLIENT";
  CheckoutEligibility2["SERVER_SIDE"] = "SERVER_SIDE";
  return CheckoutEligibility2;
})(CheckoutEligibility || {});
export {
  CheckoutEligibility,
  RewardUnlockStrategy,
  UserRewardStatus
};
//# sourceMappingURL=product.js.map
